<template>
    <Button type="button" icon="pi pi-th-large" @click="toggle" aria-haspopup="true" aria-controls="overlay_menu" text
        rounded severity="secondary" />
    <Menu ref="menu" id="overlay_menu" :model="items" :popup="true" />
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import Button from "primevue/button";
import Menu from "primevue/menu";
const router = useRouter();

const menu = ref();
const items = ref([
    { label: 'Definir Pareceres', icon: 'pi pi-id-card', command: () => navegarPareceres() },
    { label: 'Recursos Didáticos', icon: 'pi pi-folder', command: () => navegarCriarRecursosDidaticos() },
    {label: "Desempenho dos Alunos por área", icon: "pi pi-chart-line", command: () => navegarResumoDesempenho() },
    {label: "Desempenho geral do Alunos", icon: "pi pi-chart-line", command: () => navegarDesempenhoGeral() }
]);

const toggle = (event) => {
    menu.value.toggle(event);
};

const navegarPareceres = () => {
    router.push('/professor/elaborar-parecer');
}
const navegarCriarRecursosDidaticos = () => {
    router.push('/professor/recursos-didaticos');
}
const navegarResumoDesempenho = () => {
    router.push('/professor/resumo-desempenho');
}

const navegarDesempenhoGeral = () => {
    router.push('/professor/desempenho-alunos-geral');
}
</script>
